<template>
    <b-form-group :label="label" :label-for="labelFor">
        <div v-if="!isInputVisible && hasFile" class="text-center">
            <span>{{ file.file.name }}</span>
            <Button
                variant="secondary"
                class="mt-0 mr-0 float-right"
                @click="reUpload"
            >
                {{ $t('Component(Button):re-upload') }}
            </Button>
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mt-0 mr-1 sm float-right"
                @click="download"
                :disabled="downloading"
            >
                <b-spinner v-if="downloading" small />
                <feather-icon
                    v-if="!downloading"
                    icon="DownloadCloudIcon"
                />
            </b-button>
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mt-0 mr-1 sm float-right"
                @click="preview"
            >
                <feather-icon
                    icon="EyeIcon"
                />
            </b-button>
        </div>
        <div v-if="isInputVisible">
            <b-form-file
                :id="labelFor"
                v-model="selectedFile"
                :placeholder="$t('Component(Placeholder):choose-file-or-drop')"
                drop-placeholder="Drop file here..."
                accept="application/pdf,application/x-pdf"
                style="width: 90%;"
                @input="selectedFileChange"
            />
            <div class="cancel-button-container" v-if="showCancelButton">
                <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="secondary"
                    class="mt-0 mr-0 sm float-right"
                    @click="cancel"
                >
                    {{ $t('Component(Button):cancel') }}
                </b-button>
            </div>
        </div>
    </b-form-group>
</template>

<script>
import { BFormGroup, BFormFile, BButton, BSpinner } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import Button from "@core/components/common/Button.vue";

export default {
    components: {
        Button,
        BFormGroup,
        BFormFile,
        BButton,
        BSpinner,
    },
    directives: {
        Ripple
    },
    props: {
        file: {
            type: Object,
            default() {
                return {
                    id: null,
                };
            }
        },
        label: {
            required: true
        },
        labelFor: {
            required: true
        }
    },
    data() {
        return {
            downloading: false,
            selectedFile: null,
            showFileInput: !this.file.id || !this.file.file
        };
    },
    methods: {
        selectedFileChange() {
            this.$emit('input', this.selectedFile);
        },
        cancel() {
            this.selectedFile = null;
            this.$emit('input', this.selectedFile);
        },
        reUpload() {
            this.showFileInput = true;
        },
        download() {
            this.downloading = true;
            this.$emit('download', this.file, () => {
                this.downloading = false;
            });
        },
        preview() {
            this.$emit('preview', this.file);
        }
    },
    watch: {
        file(value) {
            if (!value.file) {
                this.showFileInput = true;
                return;
            }
            if (value.id) {
                if (!value.document || (this.showFileInput && value.file)) {
                    this.showFileInput = false;
                }
            }
        }
    },
    computed: {
        showCancelButton() {
            return this.file.id && this.hasFile;
        },
        isInputVisible() {
            if (this.file.id && this.showFileInput) {
                return true;
            }
            return !this.file.id;
        },
        hasFile() {
            return this.file.file instanceof Object;
        }
    }
}
</script>
